import React from "react";
import { useHistory, Link } from "react-router-dom";
import NewHeader from "../../Layouts/NewHeader";
import NewFooter from "../../Layouts/NewFooter";
import { CheckCircle, CurrencyRupee } from "react-bootstrap-icons";

const PaymentSuccess = () => {
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflowX: "hidden" }}
      >
        <NewHeader />
        <div
          className="mt-4 p-5"
          style={{
            background:
              "linear-gradient(180deg, rgba(23, 0, 0, 0.80) 28.15%, rgba(0, 11, 5, 0.80) 99.2%)",
            backdropFilter: "blur(30px)",
          }}
        >
          <h5 style={{ color: "#FFF", fontSize: "25px", fontWeight: "700" }}>
            Prepaid Electricity Recharge
          </h5>
        </div>
        <div className="container mx-1" style={{ flex: "1" }}>
          <div className="row">
            <div className="col-lg-8 col-xs-12">
              <div
                className="card px-5 py-5 my-3 mx-2 m-auto shadow-lg position-relative"
                style={{
                  top: "-40px",
                  borderRadius: "10px",
                  margin: "auto !important",
                }}
              >
                <div className="row mb-4" style={{ placeItems: "center" }}>
                  <div className="col-lg-6">
                    <div className="d-flex align-items-center gap-3 justify-content-start">
                      <i
                        className="fa-regular fa-circle-check"
                        style={{ fontSize: "45px", color: "#06B402" }}
                      ></i>

                      <h1
                        style={{
                          margin: "0px",
                          fontWeight: "600",
                          color: "#000",
                        }}
                      >
                        <i className="fa-solid fa-indian-rupee-sign"></i>
                        2000
                      </h1>
                    </div>
                    <p
                      className="mt-2 mb-4"
                      style={{
                        fontSize: "16px",
                        margin: "0px",
                        fontWeight: "400",
                      }}
                    >
                      Your Payment is successfully done!
                    </p>

                    <div className="mb-3">
                      <div className="d-flex mt-4 mb-3 gap-2">
                        <Link
                          to="/dashboard"
                          className="btn my-2 w-100 fw-700"
                          role="button"
                          style={{
                            color: "black",
                            fontWeight: 700,
                            fontSize: "15px",
                            background: "#D3D3D3",
                            borderRadius: "5px",
                            boxShadow:
                              "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                            textTransform: "capitalize",
                          }}
                        >
                          Home
                        </Link>
                        <Link
                          to="/view_details"
                          className="btn my-2 w-100 text-white font-weight-bold fs-15 rounded text-capitalize"
                          role="button"
                          style={{
                            fontWeight: 700,
                            background:
                              "linear-gradient(90deg, #433232 5.56%, #383735 95.49%)",
                            boxShadow:
                              "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                          }}
                        >
                          QR Code
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <NewFooter />
      </div>
    </>
  );
};

export default PaymentSuccess;
